module.exports = __webpack_public_path__ + "img/email.93a46a56.svg";